module.exports = __webpack_public_path__ + "img/index10.b72ae4f1.png";